/** `/client/:planId` — the client progress page (moat plan §5.2): proof, exceptions, approvals, "approve phase". */
import { createFileRoute } from '@tanstack/react-router'
import { ClientProgressView } from '#/components/studio/client-progress'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/client/$planId')({
  head: () => ({ meta: [{ title: m.st_cl_proof_title() }] }),
  component: ClientPlanPage,
})

function ClientPlanPage() {
  const { planId } = Route.useParams()
  return <ClientProgressView planId={planId} />
}
